import React, { useState } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import Button from '../Button';
import EnterPayment from '../EnterPayment';
import Error from '../Error';
import NewAccountScreenLayout from './NewAccountScreenLayout';
import colors from '../../styles/colors';

import step4Image from '../../assets/images/new-account/04.jpg';

const STORAGE_KEY_PAYMENT_TOKEN = 'newAccount_paymentToken';

const PAYMENT_FORM_ID = 'new-account-payment-form';

const PaymentMethodBlock = styled.div`
  max-width: 600px;
`;

const BodyText = styled.p`
  color: ${colors.grey3};
  font-size: 16px;
  line-height: 1.8em;
  margin-bottom: 1.8em;
`;

export default function PaymentStep({ onSuccess }) {
  const history = useHistory();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleTokenReceived = async (tokenId) => {
    sessionStorage.setItem(STORAGE_KEY_PAYMENT_TOKEN, tokenId);
    if (onSuccess) onSuccess();
    else history.push('/new-account/step/6');
  };

  const handleTokenError = () => {
    setLoading(false);
  };

  const handleBack = () => {
    history.push('/new-account/step/4');
  };

  const footer = (
    <>
      <Button type="button" text="Back" onClick={handleBack} width="auto" />
      <Button
        margin="0"
        text="Complete Registration"
        type="button"
        onClick={() => document.getElementById(PAYMENT_FORM_ID)?.requestSubmit()}
        loading={loading}
        width="auto"
      />
    </>
  );

  return (
    <NewAccountScreenLayout
      stepNumber={5}
      screenImageSrc={step4Image}
      title="Enter Payment Method"
      showSignInLink={false}
      footer={footer}
    >
      <PaymentMethodBlock>
        <BodyText>
          You will be charged a $299.00 onboarding fee.
        </BodyText>
        <BodyText>
          All accounts will be charged a minimum monthly fee of $99 as a credit towards campaign fees and word-of-mouth engine fees incurred each 30 day period.
        </BodyText>
        <BodyText>
          After the minimum monthly fee, you will be charged based on the volume of messages sent and word-of-mouth engine discounts activated each month.
        </BodyText>
        <EnterPayment
          formId={PAYMENT_FORM_ID}
          setError={setError}
          onTokenReceived={handleTokenReceived}
          onTokenError={handleTokenError}
          onSubmitting={setLoading}
        />
        {error && <Error error={error} margin="16px 0 0 0" />}
      </PaymentMethodBlock>
    </NewAccountScreenLayout>
  );
}
